import { render, staticRenderFns } from "./briefcase.html?vue&type=template&id=2420f2e7&scoped=true&"
import script from "./briefcase.js?vue&type=script&lang=js&"
export * from "./briefcase.js?vue&type=script&lang=js&"
import style0 from "./briefcase.scss?vue&type=style&index=0&id=2420f2e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420f2e7",
  null
  
)

export default component.exports